import {theme} from "./Tema";

export const VALORENVIOGRATIS = 350000

export const ESTADOSCOLECCIONES = [
    {
        nombre: 'Publicada',
        color: '#796254'
    },
    {
        nombre: 'Archivada',
        color: '#808080'
    },
]

export const ESTADOPEDIDO = [

    {
        nombre: 'Nuevo',
        color: '#796254'
    },
    {
        nombre: 'Seguimiento',
        color: '#796254'
    },
    {
        nombre: 'Enviado',
        color: '#5a6a85'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
]


export const ESTADOSPRENDA = [
    {
        nombre: 'Publicado',
        color: '#796254'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
]

export const ESTADOSPAGO = [
    {
        nombre: 'APPROVED',
        color: '#808080'
    },
    {
        nombre: 'DECLINED',
        color: '#808080'
    },

]

export const CATEGORIAS = [
    {
        nombre: 'Accesorios',
        color: '#796254'
    },
    {
        nombre: 'Superior',
        color: '#796254'
    },
    {
        nombre: 'Inferior',
        color: '#808080'
    },
]


export const TIPOSPRENDA = [
    {
        nombre: 'Cinturón',
        color: '#796254'
    },
    {
        nombre: 'Pañoleta',
        color: '#796254'
    },
    {
        nombre: 'Prendedor',
        color: '#796254'
    },
    {
        nombre: 'Bermuda',
        color: '#796254'
    },
    {
        nombre: 'Pantalón',
        color: '#796254'
    },
    {
        nombre: 'Blusa',
        color: '#796254'
    },
    {
        nombre: 'Chaleco',
        color: '#796254'
    },


]

export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: theme.palette.primary.main
    },
    {
        nombre: 'Admin',
        color: theme.palette.secondary.main
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]
